export enum SchmancyEvents {
	NavDrawer_toggle = 'SchmancytoggleSidebar',
	ContentDrawerToggle = 'ContentDrawerToggle',
	ContentDrawerResize = 'ContentDrawerResize',
}
